// extracted by mini-css-extract-plugin
export default {"container":"TopicItem_container__Gj1Yv","thumbnail":"TopicItem_thumbnail__qqMVv","overlay":"TopicItem_overlay__vsBfR","topicName":"TopicItem_topicName__PLt57"};